module.exports = __webpack_public_path__ + "img/icon_industrial_hk.deb1d8c4.png";